var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SimplePageNorm',{attrs:{"title":"药方校验"}},[_c('CheckContent',{staticStyle:{"width":"100%","height":"100%"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }